<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #FFF6E5; height:100% ">
        <v-toolbar class="slide-card-up mb-8" dense :color="miColorNaranja" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo2.png" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row v-if="reservaEtapaProveedor" dense class="slide-card-up" justify="center">
            <h1 class="mt-0 ma-4 mr-12">Hola {{ reservaEtapaProveedor.proveedor_nombre }}</h1>
        </v-row>
        <v-row dense class="slide-card-up">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    Gracias por tu respuesta.
                </p>
            </v-col>
        </v-row>



        <v-container>
            <v-row v-if="accion === 'CONFIRMAR' && !confirmacionEnviada" dense class="slide-card-up" justify="center">
                <v-col v-if="hasTarifas" cols="12" md="8" class="text-center">
                    <p style="font-size: 1.2rem;" class="mb-6">Tenemos las siguientes tarifas para cada una de los tipos de habitaciones.</p>
                    <p style="font-size: 1.2rem;" class="mb-6">A continuación puedes rectificarlas o en caso de estar correctas, solo Confirmar.
                        Tambien puedes escribirnos algún comentario que debamos saber.</p>
                </v-col>
                <v-col v-else cols="12" md="8" class="text-center">
                    <p style="font-size: 1.2rem;" class="mb-6">Nos puedes especificar las tarifas de cada tipo de habitación</p>
                    
                </v-col>
                <v-col v-if="hasHabitacionIndividual" cols="12" md="8">
                    <v-text-field v-model="tarifa_ind" label="Tarifa individual" type="number" outlined
                        dense></v-text-field>
                </v-col>
                <v-col v-if="hasHabitacionDoble" cols="12" md="8">
                    <v-text-field v-model="tarifa_doble" label="Tarifa doble" type="number" outlined
                        dense></v-text-field>
                </v-col>
                <v-col v-if="hasHabitacionTriple" cols="12" md="8">
                    <v-text-field v-model="tarifa_triple" label="Tarifa triple" type="number" outlined
                        dense></v-text-field>
                </v-col>

                <v-col cols="12" md="8">
                    <v-textarea :rows="5" outlined v-model="comentario" :placeholder="'¿Algún comentario?'">
                    </v-textarea>
                </v-col>
                <v-col cols="12" class="text-center">
                    <v-chip
                        link
                        large
                        @click="tarifasVisiblesValidas ? confirmDisponibilidad() : null"
                        class="ma-2 px-8 mr-8"
                        :class="{ 'hover-color': tarifasVisiblesValidas }"
                        :color="!tarifasVisiblesValidas ? 'grey' : miColorAzul"
                        :text-color="!tarifasVisiblesValidas ? 'black' : miColorNaranja"
                        style="font-size: 1.2rem;"
                        :disabled="!tarifasVisiblesValidas"
                    >
                        Confirmar disponibilidad y tarifas
                        <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                    </v-chip>
                </v-col>
            </v-row>

            <v-row v-if="accion === 'CANCELAR'" dense class="slide-card-up" justify="center">
                <v-col cols="12" md="8" class="text-center">
                    
                    <p style="font-size: 1.2rem;" class="mx-16">
                        Si tienes alguna razón que debamos saber puedes enviarnos un comentario.
                    </p>
                    <v-row justify="center">
                        <v-col cols="12" md="8">
                            <v-textarea :rows="5" outlined v-model="comentario" :placeholder="'¿Algún comentario?'">
                            </v-textarea>
                        </v-col>
                    </v-row>

                    <v-chip
                        label
                        link
                        large
                        :color="'blue lighten-1'"
                        text-color="white"
                        class="mt-2 px-8"
                        @click="closeTab"
                    >
                        Cerrar
                    </v-chip>
                </v-col>
            </v-row>

            <v-row v-if="accion === 'CONFIRMAR' && confirmacionEnviada" dense class="slide-card-up" justify="center">
                <v-col cols="12" md="8" class="text-center">
                    
                    <v-chip
                        label
                        link
                        large
                        :color="'blue lighten-1'"
                        text-color="white"
                        class="mt-2 px-8"
                        @click="cerrar"
                    >
                        Cerrar
                    </v-chip>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            reservaEtapaProveedor: null,
            accion: null,
            hash: null,
            tarifa_ind: null,
            tarifa_doble: null,
            tarifa_triple: null,
            comentario: null,

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorAmarillo: '#FFF6E5',
            confirmacionEnviada: false,


        };
    },
    computed: {
        hasTarifas() {
            const reserva = this.reservaEtapaProveedor || {};
            return ['tarifa_ind', 'tarifa_doble', 'tarifa_triple'].some((key) => {
                const value = reserva[key];
                return value !== null && value !== undefined && value !== '';
            });
        },

        hasTarifaIndividual() {
            return this.tarifa_ind !== null && this.tarifa_ind !== undefined && this.tarifa_ind !== '';
        },
        hasTarifaDoble() {
            return this.tarifa_doble !== null && this.tarifa_doble !== undefined && this.tarifa_doble !== '';
        },
        hasTarifaTriple() {
            return this.tarifa_triple !== null && this.tarifa_triple !== undefined && this.tarifa_triple !== '';
        },
        hasComentario() {
            return this.comentario !== null && this.comentario !== undefined && this.comentario !== '';
        },

        hasHabitacionIndividual() {
            return this.reservaEtapaProveedor && this.reservaEtapaProveedor.reserva && 
                   this.reservaEtapaProveedor.reserva.cant_habitaciones_individuales > 0;
        },
        hasHabitacionDoble() {
            return this.reservaEtapaProveedor && this.reservaEtapaProveedor.reserva && 
                   (this.reservaEtapaProveedor.reserva.cant_habitaciones_dobles > 0 || this.reservaEtapaProveedor.reserva.cant_habitaciones_dobles_matrimoniales > 0);
        },
        hasHabitacionTriple() {
            return this.reservaEtapaProveedor && this.reservaEtapaProveedor.reserva && 
                   this.reservaEtapaProveedor.reserva.cant_habitaciones_triples > 0;
        },
        tarifasVisiblesValidas() {
            const tarifasVisibles = [];

            if (this.hasHabitacionIndividual) tarifasVisibles.push(this.tarifa_ind);
            if (this.hasHabitacionDoble) tarifasVisibles.push(this.tarifa_doble);
            if (this.hasHabitacionTriple) tarifasVisibles.push(this.tarifa_triple);

            return tarifasVisibles.length > 0 && tarifasVisibles.every((tarifa) => this.tarifaEsValida(tarifa));
        },
    },



    mounted() {
        this.accion = (this.$route.params.accion || '').toUpperCase();
        this.hash = this.$route.params.hash;
        if (this.hash) {
            this._getReservaEtapaProveedorByHash(this.hash);
        }
    },

    methods: {
        ...mapActions("caminos", ["getReservaEtapaProveedorByHash", "setEstadoReservaEtapaProveedor"]),

        tarifaEsValida(value) {
            if (value === null || value === undefined || value === '') {
                return false;
            }

            const normalizedValue = String(value).trim().replace(',', '.');
            return /^\d+(\.\d+)?$/.test(normalizedValue) && Number(normalizedValue) > 0;
        },

        async _getReservaEtapaProveedorByHash(hash) {
            const res = await this.getReservaEtapaProveedorByHash([hash]);
            if (res && res.reserva_etapa_proveedor) {
                this.reservaEtapaProveedor = res.reserva_etapa_proveedor;

                await this.setEstadoReservaEtapaProveedor([this.hash, this.accion, this.tarifa_ind, this.tarifa_doble, this.tarifa_triple, this.comentario]);
               

                this.tarifa_ind = this.reservaEtapaProveedor.tarifa_ind != null ? this.reservaEtapaProveedor.tarifa_ind : '';
                this.tarifa_doble = this.reservaEtapaProveedor.tarifa_doble != null ? this.reservaEtapaProveedor.tarifa_doble : '';
                this.tarifa_triple = this.reservaEtapaProveedor.tarifa_triple != null ? this.reservaEtapaProveedor.tarifa_triple : '';

                this.comentario = this.reservaEtapaProveedor.comentario != null ? this.reservaEtapaProveedor.comentario : '';

                
            }
        },

        async confirmDisponibilidad() {
            await this.setEstadoReservaEtapaProveedor([this.hash, 'CONFIRMAR', this.tarifa_ind, this.tarifa_doble, this.tarifa_triple, this.comentario]);
            this.confirmacionEnviada = true;
        },

        async closeTab() {
            if (this.comentario !== null){
               await this.setEstadoReservaEtapaProveedor([this.hash, 'CANCELAR', this.tarifa_ind, this.tarifa_doble, this.tarifa_triple, this.comentario]);
            }
            window.close();
        },

        async cerrar() {
            window.close();
        },

       

    },
}

</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: 4px solid #FF9C00 !important;
    border-radius: 15px !important;
}

.flying-document-container {
    position: relative;
    height: 150px;
    width: 100%;
    overflow: hidden;
}

.flying-document {
    position: relative;
    animation: fly 2s infinite ease-in-out;
}

.wind-line {
    position: absolute;
    height: 2px;
    background: #FF9C00;
    opacity: 0.6;
    animation: wind 2s infinite ease-in-out;
}

.wind-line-1 {
    width: 50px;
    top: 40%;
    left: 30%;
}

.wind-line-2 {
    width: 30px;
    top: 50%;
    left: 45%;
    animation-delay: 0.2s;
}

.wind-line-3 {
    width: 40px;
    top: 60%;
    left: 35%;
    animation-delay: 0.4s;
}


@keyframes fly {
    0% {
        transform: translateX(-100%) translateY(20px) rotate(0deg);
    }

    50% {
        transform: translateX(0) translateY(0px) rotate(5deg);
    }

    100% {
        transform: translateX(100%) translateY(20px) rotate(0deg);
    }
}

@keyframes wind {
    0% {
        transform: translateX(-100%) scaleX(0.5);
        opacity: 0;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        transform: translateX(100%) scaleX(1);
        opacity: 0;
    }
}

.pulse-text {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

.hover-color {
    transition: transform 0.2s ease, filter 0.2s ease;
}

.hover-color:hover {
    cursor: pointer;
    filter: brightness(1.08);
    transform: translateY(-1px);
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}
</style>
